<div class="d-flex">
	<div class="display-6 ms-1 mt-2 mb-1">Employees</div>
	<div class="ms-auto">
		<app-record-control-footer
			[hideAdd]="false"
			[hideCancel]="true"
			[hideDelete]="true"
			[hideSave]="true"
			(onAddChange)="new()"
		></app-record-control-footer>
	</div>
</div>
<p-divider></p-divider>
<app-employee-list></app-employee-list>
